<template>
  <div class="menu-02" id="Menu02">
    <v-card
      elevation="0"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label class="ml-5 mr-15 my-5" style="color: #444444; font-size: 20px">
          {{ $t("usermanagement") }}
        </label>
      </v-system-bar>
      <!-- ******** header, add new -->
      <v-layout row="wrap" align-center>
        <v-flex my-5>
          <div class="title-div-mobile">
            <title-block
              :relative="$vuetify.breakpoint.name !== 'xs' ? true : false"
              top="1"
              left="2.6"
              width="300"
              height="60"
              class="title-text-mobile"
            >
              {{ $t("usermanagement") }}</title-block
            >
          </div>
        </v-flex>
        <v-spacer />
      </v-layout>

      <!-- ******** header, add new -->
      <!-- header, add new ******** -->

      <!-- ******** search -->
      <v-layout row="wrap" align-center class="mx-7">
        <v-flex xs12 sm4 md10 my-5 align-self-center style="min-width: 200px">
          <v-text-field
            v-model="search"
            outlined
            dense
            color="#2f9a61"
            :placeholder="searchName()"
            class="text"
            style="border-color: #d9d9d9; height: 40px; width: 300px"
          >
            <v-icon slot="append" class="searchicon">mdi-magnify</v-icon>
          </v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs12 sm4 md2>
          <v-btn
            type="button"
            block
            class="btn btn-outline-dark text-capitalize"
            style="border-color: #4caf50; background-color: #6cc8a0"
            v-on:click="openModalNew"
          >
            <span class="text" style="color: #ffffff"
              >&nbsp;&nbsp;&nbsp;&nbsp; {{ $t("newemployee") }}</span
            >
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- ******** table -->
      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="desserts"
        hide-default-footer
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :search="search"
        :must-sort="true"
        class="usertable p-horizontal my-5 mx-7"
      >
        <template v-slot:item.pathImage="{ item }">
          <img
            v-if="item.pathImage"
            :src="item.pathImage"
            alt="Profile"
            style="width: 50px; height: 50px; border-radius: 50%;"
          />
          <img
            v-else
            src="@/assets/imgs/defaultprofileimage.jpg"
            alt="Default Profile"
            style="width: 50px; height: 50px; border-radius: 50%;"
          />
        </template>
        <template v-slot:item.roleID="{ item }">
          <v-layout justify-center>
            <select
              disabled
              class="form-control"
              style="
                border-color: #707070;
                border-radius: 3rem;
                width: 110px;
                height: 30px;
                padding-left: 20px;
                padding-top: 5px;
                font-size: 14px !important;
              "
              v-model="item.roleID"
            >
              <option value="2">Employee</option>
              <option value="3">HR</option>
              <option value="1">Admin</option>
            </select>
            <span>
              <v-icon
                style="margin: 0 0 8px -2rem; border: none; padding-top: 3px"
                >mdi-chevron-down</v-icon
              >
            </span>
          </v-layout>
        </template>
        <template v-slot:item.carbs="{ item }">
          <v-layout justify-center style="display: flex">
            <div
              style="cursor: pointer"
              class="pr-5 mr-3"
              @click="openModalEdit(item)"
            >
              <label class="tablemanage"> Edit </label>
            </div>
            <div @click="openModalDel(item.userID, item.empID)">
              <label class="tablemanage"> Delete </label>
            </div>
          </v-layout>
        </template>
      </v-data-table>
      <!-- table ******** -->

      <!-- ******** pagination, perpage -->
      <v-layout
        row="wrap"
        align-center
        class="mt-5"
        style="margin-right: -35px"
      >
        <v-spacer />
        <v-flex my-3 mr-5 style="min-width: 240px; max-width: 315px">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            color="#E8E9EC"
          ></v-pagination>
        </v-flex>

        <v-flex shrink my-3 style="min-width: 173px">
          <select
            style="border:1px solid;border-color:#D9D9D9;border-radius:5pt; padding:5px;opacity:0.5
            background-color: #FFFFFF;width:110px;color:#4D4F5C;box-shadow: 0px 3px 6px #00000029;height:36px;"
            class="perPageText"
            v-model="itemsPerPage"
          >
            <option value="10">10 of {{ totalCount }}</option>
            <option value="15">15 of {{ totalCount }}</option>
            <option value="20">20 of {{ totalCount }}</option>
            <option value="25">25 of {{ totalCount }}</option>
          </select>
          <span>
            <v-icon style="margin: 0.5rem 0 0 -2rem; vertical-align: top"
              >mdi-chevron-down</v-icon
            >
          </span>
        </v-flex>
      </v-layout>
      <!-- pagination, perpage ******** -->
    </v-card>
    <!-- Modal -->
    <Modal
      v-show="isModalAddVisible"
      title="newemployee"
      :companyID="companyID"
      :userID="userID"
      :password="password"
      @close="closeModalNew"
    ></Modal>
    <Modal
      v-show="isModalEditVisible"
      title="editemployee"
      :companyID="companyID"
      :employeeID="employeeID"
      :empID="empID"
      :empName="employeeName"
      :email="email"
      :pathImage="pathImage"
      :position="positionID"
      :role="roleID"
      :userID="userID"
      :password="password"
      :lockstatus="lockstatus"
      :check_Id="check_id"
      @close="closeModalEdit"
    ></Modal>
    <ModalDel
      v-show="isModalDeleteVisible"
      :title="DeleteEmployeebyID"
      message="Are you sure you want to delete this employee?"
      :empIdToDelete="empID_Del"
      flag="removeemployee"
      @close="closeModalDel"
    ></ModalDel>

    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#6CC8A0"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "../Mixins/GlobalMixin";
import Modal from "./Modal.vue";
import ModalDel from "@/components/ModalDel.vue";
import TitleBlock from "@/components/global_component/TitleBlock";
import axios from "axios";
import enurl from "@/api/environment";
import store from "@/store";
export default {
  name: "Menu02",
  mixins: [GlobalMixin],
  props: {},
  components: { Modal, ModalDel, TitleBlock },
  data() {
    return {
      items: [
        { profileImage: "@/assets/imgs/fb.png" }

        // Add more items here
      ],
      lockstatus: false,
      mo: false,
      companyName: null,
      companyList: [],
      url: enurl.apiUrl,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      totalCount: 0,
      companyID: store.getters.companyid,
      password: null,
      characters: "a-z,A-Z,0-9",
      size: 10,
      tempID: null,
      search: "",
      employeeID: null,
      empID: null,
      empID_Del: 0,
      employeeName: null,
      email: null,
      pathImage: null,
      positionID: null,
      roleID: null,
      userID: null,
      check_id: 0,
      isModalAddVisible: false,
      isModalEditVisible: false,
      isModalDeleteVisible: false,
      dialog: false,
      userId: store.getters.userid,
      desserts: [],
      DeleteEmployeebyID: null
    };
  },
  mounted: function() {
    let self = this;
    let language = "en";
    if (language == "en") {
      self.changeLocale("en", "us", "English", 1);
    }
    self.GetAllEmployee();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("employeeid"),
          align: "left",
          width: "200px",
          value: "empID"
        },
        {
          text: this.$t("profilepicture"),
          align: "left",
          width: "200px",
          value: "pathImage"
        },
        {
          text: this.$t("fullname"),
          value: "employeeName",
          align: "left",
          width: "200px"
        },
        {
          text: this.$t("email"),
          value: "email",
          align: "left",
          width: "230px",
          margin: "500px"
        },
        {
          text: this.$t("position"),
          align: "left",
          value: "positionID",
          width: "100px"
        },
        {
          text: this.$t("role"),
          value: "roleID",
          align: "center",
          width: "200px"
        },
        {
          text: this.$t("manage"),
          value: "carbs",
          align: "center",
          width: "200px"
        }
      ];
    }
  },
  methods: {
    changeLocale(locale, flag, title, highlighted) {
      this.currentflag = flag;
      this.$i18n.locale = locale;
      this.currentLangTitle = title;
      this.lang = highlighted;
      document.cookie = "langprod=" + locale;
      document.cookie = "flagprod=" + flag;
      document.cookie = "titleprod=" + title;
      document.cookie = "highlighted=" + highlighted;
    },
    roleIdforSort(v) {
      if (v == 1) return 2;
      if (v == 2) return 3;
      if (v == 3) return 1;
    },
    roleIdforUpdate(v) {
      if (v == 2) return 1;
      if (v == 3) return 2;
      if (v == 1) return 3;
    },
    roleIdtoName(v) {
      if (v == 1) return "Employee";
      if (v == 2) return "HR";
      if (v == 3) return "Admin";
    },
    // New
    openModalNew() {
      this.GetEmployeeAll();
      this.isModalAddVisible = true;
    },
    searchName() {
      return this.$t("searchEmpIDFullEmailPosition");
    },
    closeModalNew() {
      this.isModalAddVisible = false;
    },
    // Edit
    openModalEdit(temp) {
      this.isModalEditVisible = true;
      this.employeeID = temp.employeeID;
      this.empID = temp.empID;
      this.employeeName = temp.employeeName;
      this.email = temp.email;
      this.pathImage = temp.pathImage;
      this.positionID = temp.positionID;
      this.roleID = this.roleIdforUpdate(temp.roleID);
      this.userID = temp.username;
      this.check_id = temp.userID;
      this.password = null;
      this.lockstatus = temp.lockstatus;
    },
    closeModalEdit() {
      this.isModalEditVisible = false;
    },
    // Delete
    openModalDel(item, item1) {
      this.isModalDeleteVisible = true;
      this.empID_Del = item;
      this.DeleteEmployeebyID = "Delete Employee ID '" + item1 + "'";
    },
    closeModalDel() {
      this.isModalDeleteVisible = false;
    },
    GetAllCompany() {
      let self = this;
      axios
        .post(`${self.url}Company/GetALLCompany`)
        .then(function(response) {
          self.companyList = response.data.data;
        })
        .catch(function(error) {
          alert(error);
        });
    },
    GetAllEmployee() {
      let self = this;
      self.dialog = true;
      axios
        .post(`${self.url}EmployeeCom/GetEmployeeCom`)
        .then(function(response) {
          self.dialog = false;
          let data = response.data.data;
          self.desserts = data.map(v => ({
            ...v,
            roleID: self.roleIdforSort(v.roleID)
          }));
          self.totalCount = response.data.data.length;
        })
        .catch(function(error) {
          self.dialog = false;
          alert(error);
        });
    },
    GetEmployeeAll() {
      let self = this;
      self.password = self.generate();
      axios
        .post(`${self.url}EmployeeCom/GetEmployeeCom`)
        .then(function(response) {
          let a = response.data.data.length + 1;
          if (a < 100) {
            self.userID = "U000" + a;
          } else if (a < 1000) {
            self.userID = "U00" + a;
          } else if (a < 10000) {
            self.userID = "U0" + a;
          } else {
            self.userID = "U" + a;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    generate() {
      let charactersArray = this.characters.split(",");
      let CharacterSet = "";
      let tempPassword = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "0123456789";
      }
      if (charactersArray.indexOf("#") >= 0) {
        CharacterSet += "![]{}()%&*$#^<>~@|";
      }

      for (let i = 0; i < this.size; i++) {
        tempPassword += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      return tempPassword;
    }
  }
};
</script>

<style scoped>
.a {
  fill: #43425d;
}
.editButton :hover {
  fill: #4b9160;
}
.mdi-close:hover {
  color: red !important;
}
.searchText {
  height: 34px;
  width: 350px;
  font-size: 14px;
}
.jv-breadcrumb {
  background-color: #13322c;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  border-radius: 0;
  border: none;
}
.jv-breadcrumb p {
  padding: 15px 10px;
}

.jv-content {
  /* margin: 1.5rem 2rem;
  padding: 3rem; */
  background-color: rgba(255, 255, 255, 1);
  border: none;
}

.btn-new {
  border-color: #13322c;
}
.btn-new:hover {
  border-color: #4caf50 !important;
  background-color: #4caf50 !important;
}
.jv-sub {
  display: inline;
  padding-left: 20px;
  color: rgba(47, 154, 97, 1);
  font-weight: bold;
}

.jv-announcements {
  margin: 10px 15px 0;
  padding: 15px 0px 10px;
  border-bottom: 1px solid rgba(233, 233, 240, 1);
}
.jv-announcements p {
  font-size: 14px;
  color: rgba(67, 66, 93, 1);
}
.jv-announcements p:first-child {
  font-size: 18px;
  font-weight: bold;
}
.jv-announcements p:last-child {
  font-size: 14px;
  color: rgba(47, 154, 97, 1);
}

.jv-announcements .jv-btn-edit {
  display: inline-block;
  width: 50%;
  font-size: 22px;
  color: rgba(77, 79, 92, 1);
}
.jv-announcements .jv-btn-edit :hover {
  color: rgba(47, 154, 97, 1);
}
.jv-announcements .jv-btn-del {
  display: inline-block;
  width: 50%;
  font-size: 26px;
  color: rgba(77, 79, 92, 1);
}
.jv-announcements .jv-btn-del:hover {
  color: rgba(229, 76, 71, 1);
}

.btn-group {
  margin: 0 auto;
  padding-top: 25px;
  width: auto;
}
.btn-group button {
  margin: 0 10px;
  border-color: rgba(232, 233, 236, 1);
  color: rgba(77, 79, 92, 1);
  border-radius: 3px !important;
}
.btn-group button.active {
  background-color: #13322c !important;
  border-color: #13322c !important;
}
.text-hover:hover {
  color: white !important;
}
.v-data-table >>> thead {
  font: 15px "Source Sans Pro", sans-serif;
  letter-spacing: 0;
  font-weight: 700;
  background-color: #dbdbda;
}
.searchicon {
  background-color: #6cc8a0;
  padding-top: 3px;
  margin-right: -12px;
  margin-top: -8px;
  margin-bottom: -6px;
  height: 40px;
  width: 40px;
}
.tablemanage {
  cursor: pointer;
  color: #6cc8a0;
}
/* ::v-deep .v-pagination__item {
  color: #4d4f5c !important;
  opacity: 0.5 !important;
} */

@media only screen and (max-width: 768px) {
  .card-mobile {
    margin-left: 1rem !important;
  }
}

@media only screen and (max-width: 414px) {
  .title-div-mobile {
    width: auto !important;
    margin-left: 10% !important;
  }
}

@media only screen and (max-width: 375px) {
  .title-div-mobile {
    width: auto !important;
    margin-left: 10% !important;
  }
}

@media only screen and (max-width: 320px) {
  .title-div-mobile {
    width: auto !important;
    margin-left: 10% !important;
  }

  .title-text-mobile {
    width: 113% !important;
    font-size: 20px;
  }
}
</style>
